module.exports = __webpack_public_path__ + "static/media/lock-icon-white.c888ab83.svg";